<template>
  <span
    class="inline-flex whitespace-nowrap tabular-nums"
    :class="compact ? 'flex-col items-center' : 'items-baseline gap-[0.3em]'"
    :title="formatFullDuration(seconds, t)"
  >
    <span v-for="part in durationParts(seconds, t)" :key="part.unit">
      {{ part.value }}<span class="ml-px text-[0.8em]">{{ part.unit }}</span>
    </span>
  </span>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { durationParts, formatFullDuration } from '@/utils/formatDuration';

defineProps({
  seconds: {
    type: Number,
    required: true,
  },
  compact: Boolean,
});

const { t } = useI18n();
</script>
